import React from 'react';
import async from 'async';
import axios from '../../lib/AxiosInstance';
import Select from 'react-select';
import md5 from 'md5';

import './WistiaUploader.scss';

class WistiaUploader extends React.Component {

    updateUsersList() {
        var users = [];

        _.each(this.users, user => {
            var label = user.name;

            users.push({
                value: user.id,
                label: label,
                email: user.email,
                role: user.role
            });
        });

        this.setState({ users: users, tableUsers: _.take(users, 10) });
    }

    embedVideo(videoHash) {
        this.resetVideoEmbed();

        if (document.getElementsByClassName('wistia_injected_style') !== null) {
            var styles = document.getElementsByClassName('wistia_injected_style');

            for (var i = 0; i < styles.length; i++) {
                styles[i].remove();
            }
        }

        var wistia_embed = document.createElement('div');
        wistia_embed.className = `wistia_embed wistia_async_${videoHash}`;
        wistia_embed.style.width = '640px';
        wistia_embed.style.height = '360px';
        wistia_embed.style.boxShadow = '0 1px 2px 0px rgba(0, 0, 0, 0.2);';

        this.setVideoEmbed(wistia_embed, videoHash);
    }

    deleteVideo(videoHash) {

        if (videoHash) {
            axios.get(`api/salestv/wistia-video-delete/${videoHash}`).then(deletedVideo => {
                console.log('deleted video:', deletedVideo);

                const videos = Object.assign({}, this.state.videos);
                delete videos[deletedVideo.data.name];
                this.setState({ videos });
            }).catch(error => {
                console.log(error);
            });
        }
    }

    resetVideoEmbed() {
        document.getElementById('wistiaVideoEmbed').innerHTML = '';
        document.getElementById('wistiaVideoEmbed').style.display = 'none';
    }

    setVideoEmbed(video, videoHash) {
        _wq.push({
            id: videoHash,
            onReady: () => {
                let v = Wistia.api(videoHash);
                v.play();
                v.bind('pause', this.resetVideoEmbed);
                v.bind('end', this.resetVideoEmbed);
            },
        });

        document.getElementById('wistiaVideoEmbed').appendChild(video);
        document.getElementById('wistiaVideoEmbed').style.display = 'inline-block';
    }

    handleFileUpload(e, user) {
        const stateVideos = this.state.videos;

        new Promise((resolve, reject) => {
            const file = e.target.files[0];
            if (file.size/1024/2014 > 70) {
                return reject('Files sizes over 70MB are not allowed');
            }

            const token = 'e1c6ed9ddc12d7483c155929bee01f26a0fd870ecdc196070388de82153a6927';
            const url = `https://upload.wistia.com/?access_token=${token}&name=${user.value}&description=${user.label}&project_id=${this.projectHash}`;
            const formData = new FormData();
            formData.append('file',file);
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            resolve(axios.post(url, formData, config));
        })
        .then(video => {
            const updatedVideos = Object.assign({}, stateVideos, {[user.value]: video.data.hashed_id});
            this.setState(Object.assign({}, stateVideos, {videos: updatedVideos}));
        }).catch(error => {
            Raven.captureException(error, { extra: {userId: user.value} });
            const updatedVideos = Object.assign({}, stateVideos, {[user.value]: {error}});
            this.setState(Object.assign({}, stateVideos, {videos: updatedVideos}));
        });
        const updatedVideos = Object.assign({}, stateVideos, {[user.value]: {uploading: true}});
        this.setState(Object.assign({}, stateVideos, {videos: updatedVideos}));
    }

    filterUsers(event) {
        let tableUsers;
        const stateVideos = this.state.videos;

        if (event.target.value.length > 0) {
            tableUsers = _.take(_.filter(this.state.users, (user) => {
                const names = _.toLower(user.label).split(' '); 
                const roles = user.role ? _.toLower(user.role.name).split(' ') : [];
                const hasVideo = stateVideos[user.value] ? [':video'] : [''];
                return _.some(_.concat(names, roles, hasVideo), s => s.startsWith(_.toLower(event.target.value)));
            }), 10);
        } else {
            tableUsers = _.take(this.state.users, 10);
        }
        this.setState({ tableUsers });
    }

    getInitials(name) {
        const nameArr = name.split(' ');
        if (nameArr.length === 1) {
            return name[0];
        } else if (nameArr.length > 1) {
            return nameArr[0][0] + nameArr[nameArr.length-1][0]
        } else {
            return '';
        }
    }

    renderFileStatus(video, user) {
        if (!video) {
            return (<div>
                <label htmlFor={'fileupload' + user.value}>
                    <i className='fa fa-plus file-status'></i>
                    <span className='uploadVideo status-text'>Ladda upp</span>
                </label>
                <input
                    id={'fileupload' + user.value}
                    style={{display: 'none'}}
                    onChange={(e)=> this.handleFileUpload(e, user)}
                    type='file' 
                    name='file'
                    accept='video/mp4,video/x-m4v,video/*' />
            </div>) 
        } else if (video.error) {
            return (<div title={video.error}><i className='fa fa-exclamation-circle file-status'></i><span className='status-text'>Misslyckades </span></div>)
        } else if (video.uploading) {
            return (<div><i className='fa fa-spinner fa-spin file-status'></i><span className='status-text'>Laddar...</span></div>)
        } else {
            return (<div><i className='fa fa-check'></i><span className='status-text'>Uppladdad</span></div>)
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            clientId: props.clientId,
            userId: null,
            users: [],
            tableUsers: [],
            videos: {},
            loaded: false,
        };

        this.initiated = false;
        this.uploadAllowed = true;
        this.cancelled = false;

        this.users = {};

        this.projectHash = null;
        this.currentVideoHash = null;

        this.updateUsersList = this.updateUsersList.bind(this);
        this.embedVideo = this.embedVideo.bind(this);
        this.deleteVideo = this.deleteVideo.bind(this);
    }

    render() {
        if (this.state.loaded) {
            const tableRows = this.state.tableUsers.map((user) => {
                const video = _.find(this.state.videos, (v,i) => i == user.value );
                const fileStatus = this.renderFileStatus(video, user);
                return (
                    <tr key={user.value}>
                        <td className='avatar-col'>
                            <div className='user-holder'>
                                <div title={user.label} className='userImage'>
                                    <div className='initials'>
                                        <span>{this.getInitials(user.label)}</span>
                                    </div>
                                    <img src={`//gravatar.com/avatar/${md5(user.email)}?size=50&d=blank`} className='avatar' alt={user.value} />
                                </div>
                            </div>
                        </td>

                        <td>{user.label}</td>
                        <td>{user.role ? user.role.name : ''}</td> 
                        <td>{fileStatus}</td>
                        <td>{(typeof video === 'string') && <i className='fa fa-play-circle' onClick={ () => this.embedVideo(video)}></i>}</td>
                        <td>{(typeof video === 'string') && <i className='fa fa-trash' onClick={ () => this.deleteVideo(video) }></i>}</td>
                    </tr>
                )
            })
            return (
                <div className='sales-video'>
                    <div className='wistiaUploaderWrapper'>
                        <div className='heading-wrapper'>
                            <p>Välj en film som ska spelas upp när en användare skapar en order.</p>
                            <input
                                className='search-input'
                                placeholder='Sök användare'
                                value={this.state.userQuery}
                                onChange={(e)=> this.filterUsers(e)}
                            />
                        </div>
                        <table className='wistia-table'>
                            <thead>
                                <tr>
                                    <th colSpan={2}>Användare</th>
                                    <th>Roll</th> 
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className='videoModal'>
                        <div id='wistiaVideoEmbed'></div> 
                    </div>
                </div>
            );
        } else {
            return (<div className='loading-users'>
                    <i className='fa fa-spinner fa-3x fa-spin'></i>
                </div>);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.users.length) {
            return this.updateUsersList();
        }
    }

    componentDidMount() {
        if (!this.initiated && this.state.clientId) {
            this.initiated = true;

            window._wapiq = window._wapiq || [];
            window._wq = window._wq || [];

            async.parallel({
                users: (callback) => {
                    axios.get('/api/user')
                    .then(data => {
                        callback(null, data.data)
                    })
                    .catch(error => {
                        callback(error)
                    });
                },
                videos: (callback) => {
                    axios.get('/api/salestv/wistia-videos')
                    .then(data => {
                        callback(null, data.data)
                    })
                    .catch(error => {
                        callback(error)
                    });
                },
                projectHash: (callback) => {
                    axios.get('/api/salestv/wistia-project-hash')
                    .then(data => {
                        callback(null, data.data)
                    })
                    .catch(error => {
                        callback(error)
                    });
                },
            },
            (err, results) => {
                if (err) return console.log(err);
                let videos = {};

                this.users = _.keyBy(results.users, 'id');

                _.each(results.videos, video => {
                    videos[video.name] = video.hashed_id;
                });

                this.projectHash = results.projectHash;

                if (!this.cancelled) {
                    console.log('loaded:', this);
                    this.setState({ loaded: true, videos: videos });
                }
            });
        }
    }

    componentWillUnmount() {
        this.cancelled = true;
    }

};

WistiaUploader.propTypes = {
    clientId: React.PropTypes.number,
};

export default WistiaUploader;



/** WEBPACK FOOTER **
 ** ./client/components/WistiaUploader/WistiaUploader.jsx
 **/